export default "__VITE_ASSET__sSgu02zE__"